/// <reference path="../../../../../../../rcwebmodels/gensetcommands.cs.d.ts" />
import * as React from 'react';
import { GensetCommandsGrid } from '../../../childcomponents/GensetCommandsGrid';

export interface GensetPingGridState {
    SelectedGensets: any[],
    RowData: server.GensetStatusUI[],
    Filters: server.GensetForwardCommandParams,
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
}

export class GensetPingControl extends React.Component<any, GensetPingGridState> {
    constructor(props: any) {
        super(props);      
        var filterSet = this.setDefaultFilters();
        this.state = { SelectedGensets: [], RowData: [], Filters: filterSet, IsCommandIssued: false, PrevSelectedItems: [] };  
    }

    componentDidMount() {
        if (this.props.gensetData != null && this.props.gensetData.length > 0) {
            this.setState({ RowData: this.props.gensetData });            
        }       
    }

    submitPingCommand() {
        var command = "PollUnit";
        var refreshGrid = this.props.refreshGrid;
        GensetCommandsGrid.submitCommands(command, null, refreshGrid);
        this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.gensetData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.gensetData) });
    }

    componentWillReceiveProps(nextprops: any) {
        this.setState({ SelectedGensets: gensetData });
        var gensetData = nextprops.gensetData;
        if (gensetData != undefined && gensetData != null && gensetData.length > 0) {
             this.setState({ RowData: gensetData });
        }       
    }
   

    setDefaultFilters() {
        var filters: server.GensetForwardCommandParams = {
            SelectedGensets: [], CommandName: "PollUnit", TempValue: ""
        };
        return filters;
    }   

    public render() {
        return <div>
            <GensetCommandsGrid selectedGensets={this.state.RowData} commandName={"PollUnit"}></GensetCommandsGrid>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitPingCommand.bind(this)}>Save</button>
                
            </div>
        </div>
    }
}